document.addEventListener("DOMContentLoaded", function () {

  const threshold = 4495; // 44,95 €

  function createBox() {
    const box = document.createElement("div");
    box.id = "fdc-free-shipping";
    box.innerHTML = `
      <div class="fdc-wrapper">
        <div class="fdc-text"></div>
        <div class="fdc-progress">
          <div class="fdc-progress-bar"></div>
        </div>
      </div>
    `;
    return box;
  }

  function updateBox() {

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        const subtotal = cart.total_price;
        const remaining = threshold - subtotal;

        const text = document.querySelectorAll("#fdc-free-shipping .fdc-text");
        const bars = document.querySelectorAll("#fdc-free-shipping .fdc-progress-bar");

        text.forEach((el, index) => {

          if (remaining > 0) {

            const percent = Math.min((subtotal / threshold) * 100, 100);

            el.innerHTML =
              "🔥 <strong>" +
              (remaining / 100).toFixed(2).replace('.', ',') +
              " €</strong> bis zum kostenlosen Versand.";

            if (bars[index]) {
              bars[index].style.width = percent + "%";
            }

          } else {

            el.innerHTML =
              "⚡ <strong>Fusion Level erreicht – Versand geht auf uns.</strong>";

            if (bars[index]) {
              bars[index].style.width = "100%";
            }

          }

        });

      });

  }

  function insertBoxes() {

    // Drawer
    const drawerSubtotal = document.querySelector("#CartContainer [class*='total']");
    if (drawerSubtotal && !document.querySelector("#CartContainer #fdc-free-shipping")) {
      const box = createBox();
      drawerSubtotal.insertAdjacentElement("afterend", box);
    }

    // Cart Page
    if (document.body.classList.contains("template-cart")) {
      const pageSubtotal = document.querySelector(".template-cart [class*='total']");
      if (pageSubtotal && !document.querySelector(".template-cart #fdc-free-shipping")) {
        const box = createBox();
        pageSubtotal.insertAdjacentElement("afterend", box);
      }
    }

    updateBox();
  }

  const observer = new MutationObserver(function () {
    insertBoxes();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});